import { NetworkProfileIpRange } from '@infuse/api/e-connector/network-profile';

export const mapIpRangeToString = (ipRanges: NetworkProfileIpRange[]): string => {
  return ipRanges.map((range) => range.ipCidrRange).join(', ');
};
